import React, { useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import lock from "../../../assets/login_page_assets/images/lock.avif";
import { Avatar } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { authUser } from "../services/authApi";
import ProfileImage from "../../Profiles/components/ProfileImage";

const LockScreen = () => {
  const navigate = useNavigate();
  document.title = `Verrouillage | ${process.env.REACT_APP_NAME}`;
  const [error, setError] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);

  const email = location.state?.email || sessionStorage.getItem("email");
  const user = JSON.parse(sessionStorage.getItem("user"))

  const { isLoading, mutate } = useMutation(authUser, {
    onSuccess: (data) => {
      if (data?.isAuthorized) {
        navigate("/dashboard");
      } else {
        setError("Mot de passe incorrect!");
        sessionStorage.clear();
      }
    },
    onError: (error) => {
      setError(error);
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: email,
      password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Mot de passe incorrect!"),
    }),
    onSubmit: (values) => {
      const { username, password } = values;
      const formData = {
        username: username,
        password: password,
        grant_type: process.env.REACT_APP_GRANT_TYPE,
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
      };
      mutate(formData);
    },
  });

  return (
    <React.Fragment>
      <div
        className="d-flex align-items-center"
        style={{
          backgroundImage: `url(${lock})`,
          backgroundSize: "cover",
          height: "100vh",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4">
                <CardBody className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Profile Verouillé 🔒</h5>
                  </div>
                  <div className="user-thumb text-center">
                    <Avatar size={100}><ProfileImage user = {user}  size={500}/></Avatar>
                    <h5 className="font-size-15 mt-3">{ user?.name || "-" }</h5>
                    <p className="font-size-15 mt-3 text-mutued">{ user?.role?.name || "-" }</p>
                  </div>
                  <div className="p-2 mt-4">
                    <form onSubmit={validation.handleSubmit}>
                      <input type="hidden" name="username" value={email} />
                      <div className="mb-3">
                        <label className="form-label" htmlFor="password-input">
                          Mot de passe
                        </label>
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <input
                            type={passwordShow ? "text" : "password"}
                            name="password"
                            id="password-input"
                            value={validation.values.password}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            className="form-control"
                            placeholder="Entrer votre mot de passe"
                            invalid={validation.touched.password && validation.errors.password}
                          />
                          {validation.touched.password && validation.errors.password && (
                            <div className="invalid-feedback">
                              {validation.errors.password}
                            </div>
                          )}
                          <button
                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                            type="button"
                            id="password-addon"
                            onClick={() => setPasswordShow(!passwordShow)}
                          >
                            <i className="ri-eye-fill align-middle fs-18"></i>
                          </button>
                        </div>
                      </div>
                      <Button
                        disabled={!(validation.isValid && validation.dirty)}
                        type="submit"
                        className="btn btn-success w-100"
                      >
                        {isLoading ? "Déverrouillage..." : "Déverrouiller"}
                      </Button>
                    </form>
                    {error && (
                      <div className="alert alert-danger mt-3" role="alert">
                        {error}
                      </div>
                    )}
                    <div className="mt-4 text-center">
                        <p className="mb-0">C'est pas moi ? retourner à la page de <Link to="/logout" className="fw-semibold text-primary text-decoration-underline"> connexion </Link> </p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LockScreen;
